var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOffer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2606 12.1337L13.2606 3.13371C12.9006 2.77371 12.4006 2.55371 11.8506 2.55371H4.85059C3.75059 2.55371 2.85059 3.45371 2.85059 4.55371V11.5537C2.85059 12.1037 3.07059 12.6037 3.44059 12.9737L12.4406 21.9737C12.8006 22.3337 13.3006 22.5537 13.8506 22.5537C14.4006 22.5537 14.9006 22.3337 15.2606 21.9637L22.2606 14.9637C22.6306 14.6037 22.8506 14.1037 22.8506 13.5537C22.8506 13.0037 22.6206 12.4937 22.2606 12.1337ZM13.8506 20.5637L4.85059 11.5537V4.55371H11.8506V4.54371L20.8506 13.5437L13.8506 20.5637Z",
    fill: "#E2E2E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35059 8.55371C8.17901 8.55371 8.85059 7.88214 8.85059 7.05371C8.85059 6.22528 8.17901 5.55371 7.35059 5.55371C6.52216 5.55371 5.85059 6.22528 5.85059 7.05371C5.85059 7.88214 6.52216 8.55371 7.35059 8.55371Z",
    fill: "#E2E2E2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer);
export default __webpack_public_path__ + "static/media/offer.a8184318.svg";
export { ForwardRef as ReactComponent };